import * as React from "react";
import { Button, Form, FormGroup, FormHelperText, HelperText, HelperTextItem, Modal, ModalVariant, Text, TextArea } from "@patternfly/react-core";

export const ShoutOutCommentModal = ({ title, message, comment, setComment, isOpen, isDelete, onClose, onAction }) => {

//  const textareaRef = React.useRef(null);
  const [errors, setErrors] = React.useState({});
  const [commentHelperText, setCommentHelperText] = React.useState(`${comment.length}/255 characters`);

  // React.useEffect(() => {
  //   if (textareaRef != null) {
  //     if (textareaRef.current != null) {
  //       textareaRef.current.focus();
  //     }
  //   }
  // }, [textareaRef]);

  const onCommentChange = (value) => {
    if (value.length > 0) {
      if (value.length === 1) {
        setComment(value);
        setCommentHelperText("1/255 character");
      } else {
        setComment(value);
        setCommentHelperText(`${value.length}/255 characters`);
      }
    } else {
      setComment(value);
      setCommentHelperText("0/255 characters");
    }
  };

  const moveCaretToEnd = (e) => {
    var temp = e.target.value;
    e.target.value = '';
    e.target.value = temp;
  };

  const onEditComment = () => {
    const err = {};
    if (comment.length < 10) {
      err.comment = "Comment should be at least 10 characters.";
      setErrors(err);
      return;
    }
    if (comment.length > 255) {
      err.comment = "Comment should be at most 255 characters.";
      setErrors(err);
      return;
    }
    if (comment !== comment.trim()) {
      err.comment = "The comment cannot have leading or trailing spaces.";
      setErrors(err);
      return;
    }
    onAction();
  };

  return (
    <Modal
      elementToFocus="#comment-textarea"
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      titleIconVariant={isDelete ? "warning" : "info"}
      description={message}
      variant={ModalVariant.medium}
      actions={[
        <Button key="action" variant={isDelete ? "danger" : "primary"} onClick={onEditComment}>
          {isDelete ? "Delete" : "Save"}
        </Button>,
        <Button key="cancel" variant="link" onClick={onClose}>
          Cancel
        </Button>
      ]}
    >
      <Form>
        <FormGroup
          fieldId="comment-textarea"
          label="Comment"
          isRequired
        >
          <TextArea
            id="comment-textarea"
            autoFocus
            autoResize={true} 
            isRequired
            placeholder="Write a comment..."
            resizeOrientation="none"
            rows={3}
            value={comment}
            onChange={(e) => onCommentChange(e.target.value)}
            onFocus={(e) => moveCaretToEnd(e)}
          />
          <FormHelperText>
            <HelperText style={{ float: 'right' }}>
              <HelperTextItem variant={'default'}>
                <Text component="small">{ commentHelperText }</Text>
              </HelperTextItem>
            </HelperText>
            <HelperText>
              <HelperTextItem variant={ Object.keys(errors).length > 0 ? "error" : "default"}>
                <Text component="small">{ errors.comment }</Text>
              </HelperTextItem>
            </HelperText>
          </FormHelperText>
        </FormGroup>
      </Form>
    </Modal>
  );
};